import { request } from '@/api/httpClient'

export async function marketingNewsItems({ limit, offset, categoryId, search }) {
  const response = await request({
    method: 'marketing/NewsItems',
    payload: {
      Limit: parseInt(limit, 10),
      Offset: parseInt(offset, 10),
      categoryId: categoryId ? Number(categoryId) : undefined,
      search,
      GetTotal: true
    }
  })

  let articles = []
  if (response.total > 0) {
    articles = response.newsItems.map((newsItem) => ({
      ...newsItem,
      url: `/news/${newsItem.id}`,
      edit_url: `/manage-news/edit/${newsItem.id}`
    }))
  }
  return {
    news_items: articles,
    total_items: response.total
  }
}

export async function marketingGetNewsItem(id) {
  return request({
    method: 'marketing/GetNewsItem',
    payload: { Id: Number(id) }
  })
}

export async function marketingAddNewsItem(newsItem) {
  return request({
    method: 'marketing/AddNewsItem',
    payload: {
      NewsCategoryId: newsItem.newsCategoryId,
      Title: newsItem.title,
      Paragraph: newsItem.paragraph,
      Summary: newsItem.summary,
      Image: newsItem.image
    }
  })
}

export async function marketingUpdateNewsItem(newsItem) {
  return request({
    method: 'marketing/UpdateNewsItem',
    payload: {
      Id: parseInt(newsItem.id, 10),
      NewsCategoryId: newsItem.newsCategoryId,
      Title: newsItem.title,
      Paragraph: newsItem.paragraph,
      Summary: newsItem.summary,
      Image: newsItem.image
    }
  })
}

export async function marketingDeleteNewsItems(newsPostIds) {
  return request({
    method: 'marketing/DeleteNewsItems',
    payload: {
      Ids: newsPostIds
    }
  })
}

export async function marketingNewsCategories() {
  return request({
    method: 'marketing/NewsCategories'
  })
}

export async function marketingAddNewsCategory(categoryName) {
  return request({
    method: 'marketing/AddNewsCategory',
    payload: {
      Name: categoryName
    }
  })
}

export async function marketingUpdateNewsCategory(category) {
  return request({
    method: 'marketing/UpdateNewsCategory',
    payload: {
      Id: Number(category.id),
      Name: category.name
    }
  })
}

export async function marketingDeleteNewsCategories(categoryIds) {
  return request({
    method: 'marketing/DeleteNewsCategories',
    payload: {
      Ids: categoryIds
    }
  })
}
